// import React from 'react';

// const NavIcon = ({ items }) => {
//     let navIcons = false;
//     if (items.icon) {
//         console.log(items);
//         console.log(items.icon);
//         navIcons = (
//             <span className="pcoded-micon">
//                 <i className={items.icon} />
//             </span>
//         );
//     }

//     return <React.Fragment>{navIcons}</React.Fragment>;
// };

// export default NavIcon;
import React from 'react';

const NavIcon = ({ items }) => {
    let navIcons = null;

    if (items.icon) {
        if (typeof items.icon === 'string') {
            // Feather icon (class-based)
            navIcons = (
                <span className="pcoded-micon">
                    <i className={items.icon} />
                </span>
            );
        } else if (typeof items.icon === 'function') {
            // Material-UI icon (React component)
            const IconComponent = items.icon;
            navIcons = (
                <span className="pcoded-micon">
                    <IconComponent />
                </span>
            );
        }
    }

    return <>{navIcons}</>;
};

export default NavIcon;
